import React, { useState, useEffect } from 'react';
import { 
    Categoria, 
    ContainerCategoria, 
    ContainerNavCategoria,
    CardListSetores, 
    CategoriaFlex,
    ContainerTitulop,
    TituloCategoria,
    ContainerVerMais,
    VermaisP,
    TitularDoSetor,
    ContainerTipoSetor,
    FlexSetor,
    TituloSetorFlex,
    ButtonSetor,
    SaibaMaisP,
    TituloSetorP

} from './Home.style.js';
import Maior from '../components/svg/maior.svg';

import API from '../examples/modelo_api_home.json'
import { useNavigate, Link } from 'react-router-dom';

import apiService from '../api/home'; 


function CategoriaPage({Item}) {
    const navigate = useNavigate();
 
    const getAmbiente =  apiService.ambiente();

    const setorestipo2 = Item.banners;

    return (
        <Categoria style={{background: Item.itembackground}}>
            <ContainerCategoria>
                <ContainerNavCategoria>
                    <CategoriaFlex>
                        <ContainerTitulop>
                            <TituloCategoria style={{color: Item.itemcolor}}>{Item.ecommercepaginaitem}</TituloCategoria>
                        </ContainerTitulop>
                        <ContainerVerMais>
                            <VermaisP style={{color: Item.itemcolor}}>Ver tudo</VermaisP>
                            <img src={Maior}/>
                        </ContainerVerMais>
                    </CategoriaFlex>
                </ContainerNavCategoria>
                <CardListSetores>

                    {setorestipo2.map((section) => (
                        <ContainerTipoSetor key={section.id}>
                            
                            <TitularDoSetor>
                                <img style={{width:'100%', height:'100%', borderRadius:20,objectFit:"cover"}} src={getAmbiente+"/"+section.urlbanneritem}/>
                                <FlexSetor>
                                    <TituloSetorFlex>
                                        <TituloSetorP>{section.textobanneritem}</TituloSetorP>
                                    </TituloSetorFlex>
                                    {/* <ButtonSetor onClick={()=>{navigate("./produto")}}><SaibaMaisP>Saiba mais</SaibaMaisP></ButtonSetor> */}
                                    <ButtonSetor onClick={() => { navigate(`./produto?categoria=${section.ordem}`) }}><SaibaMaisP>Saiba mais</SaibaMaisP></ButtonSetor>
                                </FlexSetor>
                            </TitularDoSetor>
                            
                        </ContainerTipoSetor>
                    ))}

                </CardListSetores>
            </ContainerCategoria>
        </Categoria>   
    );
}

export default CategoriaPage;
